module.exports = __webpack_public_path__ + "static/pattern-5ec852dbf0e96d8095d9d5a3b748d602.svg";